import * as React from 'react';
import { useIsDesktop } from '@cian/valuation-utils-component';

import { CounterBannerRealtors } from '../../components/CounterBannerRealtors';
import { getProgressPercentage, getTextForCounterBanner } from './utils';

export interface ICounterBannerRealtorsContainerProps {
  countSelected: number;
  onClick: () => void;
}

export const CounterBannerRealtorsContainer: React.FC<
  React.PropsWithChildren<ICounterBannerRealtorsContainerProps>
> = ({ countSelected, onClick }) => {
  const isDesktop = useIsDesktop();
  const maxAmount = 3;
  const progressPercentage = getProgressPercentage(countSelected, maxAmount);

  const phrase = React.useMemo(
    () => getTextForCounterBanner(countSelected, maxAmount, !isDesktop),
    [countSelected, isDesktop],
  );

  return (
    <CounterBannerRealtors
      text={phrase}
      count={countSelected}
      maxCount={maxAmount}
      progressPercentage={progressPercentage}
      isMobile={!isDesktop}
      onClick={onClick}
    />
  );
};
